import React from 'react';
import Formsy from 'formsy-react';
import { Grid, Link, IconButton, Box, InputLabel } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import { makeStyles } from '@material-ui/core/styles';
import DateFnsUtils from '@date-io/date-fns';
import SelectFilter from '../../common/Selector/SelectFilter';
import { treatmentStatusOptions } from '../../../enums';

const useStyles = makeStyles({
  inputGrid: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'baseline',
    minHeight: '44px',
    padding: '10px',
  },
  label: { minWidth: '80px' },
  selectorChip: { fontSize: '13px' },
});

const customStyle = {
  selector: {
    backgroundColor: '#eef2f4',
    height: '36px',
    borderRadius: 2,
    fontSize: 14,
    width: '100%',
  },
};

export default function ReferralTreatmentsFilter({
  treatmentStatuses,
  orgUnits,
  activities,
  dateFrom,
  dateTo,
  onPropsChange,
  handleClear,
  handleTreatmentsFilterSubmit,
  filterOptions,
}) {
  const classes = useStyles();

  const handleSelectChange = field => value => {
    onPropsChange(field, value);
  };

  const isValidDate = date => {
    return date && !isNaN(date.getTime());
  };

  const setDateFrom = date => {
    onPropsChange('dateFrom', date);
  };

  const setDateTo = date => {
    onPropsChange('dateTo', date);
  };

  const canFilter = () => {
    const isDateRangeValid = isValidDate(dateFrom) && (!dateTo || isValidDate(dateTo));
    return isDateRangeValid && (!dateTo || dateFrom <= dateTo);
  };

  const handleSubmit = () => {
    const activityNames = filterOptions.activityOptions
      .filter(activity => activities.includes(activity.id))
      .map(option => option.name);
    handleTreatmentsFilterSubmit(activityNames);
  };

  return (
    <Formsy.Form>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <Grid container className="advance-filter-wrapper">
          <Grid item xs={4}>
            <Box className={classes.inputGrid}>
              <InputLabel className={classes.label}>Status</InputLabel>
              <SelectFilter
                key={'status'}
                value={treatmentStatuses}
                options={treatmentStatusOptions || {}}
                onChange={handleSelectChange('treatmentStatuses')}
                classes={classes}
                customStyle={customStyle}
                fullWidth
                multiple
              />
            </Box>
          </Grid>

          <Grid item xs={4}>
            <Box className={classes.inputGrid}>
              <InputLabel className={classes.label}>Date From</InputLabel>
              <KeyboardDatePicker
                margin="normal"
                id="date-picker-dialog"
                format="dd/MM/yyyy"
                value={dateFrom}
                onChange={date => setDateFrom(date)}
                KeyboardButtonProps={{
                  'aria-label': 'change date',
                }}
                fullWidth
                maxDate={dateTo || undefined}
              />
            </Box>
          </Grid>

          <Grid item xs={4}>
            <Box className={classes.inputGrid}>
              <InputLabel className={classes.label}>Date To</InputLabel>
              <KeyboardDatePicker
                margin="normal"
                id="date-picker-dialog"
                format="dd/MM/yyyy"
                value={dateTo}
                onChange={date => setDateTo(date)}
                KeyboardButtonProps={{
                  'aria-label': 'change date',
                }}
                fullWidth
                minDate={dateFrom || undefined}
              />
            </Box>
          </Grid>

          <Grid item xs={4}>
            <Box className={classes.inputGrid}>
              <InputLabel className={classes.label}>Org Units</InputLabel>
              <SelectFilter
                key={'orgUnits'}
                value={orgUnits}
                options={filterOptions.orgUnitOptions || {}}
                onChange={handleSelectChange('orgUnits')}
                classes={classes}
                customStyle={customStyle}
                fullWidth
                multiple
              />
            </Box>
          </Grid>
          <Grid item xs={4}>
            <Box className={classes.inputGrid}>
              <InputLabel className={classes.label}>Activities</InputLabel>
              <SelectFilter
                key={'activities'}
                value={activities}
                options={filterOptions.activityOptions || {}}
                onChange={handleSelectChange('activities')}
                classes={classes}
                customStyle={customStyle}
                fullWidth
                multiple
              />
            </Box>
          </Grid>

          <Grid item xs={4}>
            <Box style={{ display: 'flex', justifyContent: 'end' }}>
              <Box pr={3}>
                <Link className="cancel-link" onClick={handleClear}>
                  Clear All
                </Link>
              </Box>
              <Box pr={2}>
                <IconButton
                  size="small"
                  disabled={!canFilter()}
                  className="search-icon"
                  onClick={handleSubmit}
                  type="submit"
                >
                  <SearchIcon />
                </IconButton>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </MuiPickersUtilsProvider>
    </Formsy.Form>
  );
}
